import React from "react";

export class CookiePolicyPTBR extends React.Component {
    render() {
        return (
            <>
                <p>
                    Data de revisão: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    Este documento foi preparado de acordo com o Regulamento da UE 2016/679 (o "GDPR") para permitir que os usuários entendam quais cookies são instalados quando
                    eles usam um portal DeepUnity DeepUnity PACSonWEB (o "Site").
                </p>
                <h2>1. Responsável pelo tratamento de dados e responsável pela proteção de dados</h2>
                <p>
                    DH Healthcare GmbH, com sede em Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, é o controlador de dados dos dados pessoais (os Dados) dos usuários do Site
                    coletados usando cookies. Para qualquer solicitação é possível escrever para a DH Healthcare GmbH no endereço físico acima mencionado ou através do endereço de
                    e-mail.
                    <br />A DH Healthcare GmbH nomeou um Data Protection Officer ("DPO"), que pode ser contatado em Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Dados tratados pela DH Healthcare GmbH</h2>
                <p>
                    Anavegação na Webenvolve o uso de cookies, pequenas cadeias de texto que os sites visitados enviam para o navegador do usuário, onde são armazenados e depois
                    transmitidos para os mesmos sites durante as visitas subsequentes. Durante a navegação num site, o utilizador pode também receber cookies no seucomputador a
                    partir de sites ou servidores web diferentes daquele que está a visitar (os chamados cookies de "terceiros"). É possível distinguir:
                    <br />
                    <br />
                    a. cookies técnicos, que permitem realizar atividades relacionadas com o funcionamento do Site.
                    <br />
                    <br />
                    b. cookies de criação de perfis, utilizados para analisar o comportamento do utilizador e, se necessário, para enviar mensagens publicitárias de acordo com as
                    preferências expressas pelo utilizador durante a navegação.
                    <br />
                    <br />
                    c. Armazenamento local, que permite a realização de atividades relacionadas à operação do Site.
                </p>
                <p>
                    <br />
                    Este site usa os seguintes cookies:
                </p>
                <h3>a) Cookies técnicos</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Anfitrião</th>
                            <th>Categoria</th>
                            <th>Descrição</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Autenticação do portal DeepUnity PACSonWEB.</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>ID da sessão do portal DeepUnity PACSonWEB.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Este cookie é definido se você optar por permitir todos os cookies e registra quando foi definido.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Registra a escolha de idioma assim que ela é alterada manualmente.</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Registra a escolha do idioma assim que ele é alterado manualmente (o idioma do navegador é usado como padrão).</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Portal do cliente no qual você fez login.</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Registra os caches de imagens locais, vinculados ao usuário.</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Necessário</td>
                            <td>Isso é usado para salvar o estado em uma viagem de ida e volta de login externo. Isso é necessário por motivos de segurança para evitar ataques CSRF e de repetição. O cookie será criptografado.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Funcional</td>
                            <td>Este cookie é definido se você optar por permitir todos os cookies e registra quando foi definido.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Cookies analíticos/de criação de perfil</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Anfitrião</th>
                            <th>Duração</th>
                            <th>Categoria</th>
                            <th>Descrição</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 anos</td>
                            <td>Analítico</td>
                            <td>Usado para distinguir usuários.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 horas</td>
                            <td>Analítico</td>
                            <td>Usado para distinguir usuários.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 anos</td>
                            <td>Analítico</td>
                            <td>Usado para manter o estado da sessão.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Armazenamento local (Host: Dobco; Categoria: Necessário)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Descrição</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td> A última ocasião em que você abriu os avisos.</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td> ID para o uso do HomeReading.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td> Registra se o tutorial já foi exibido</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td> Configurações preferenciais para compartilhar um estudo.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td> Configuração preferida para imprimir uma investigação.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td> Portal do cliente no qual você fez login.</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td> Registra se a política de cookies já foi exibida.</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td> Gravação dos fatos noticiosos importantes já mostrados.</td>
                        </tr>
                        <tr>
                            <td>Reportfontsize</td>
                            <td> Tamanho da fonte do relatório no visualizador.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> Como você fez o login (paciente/médico).</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>
                                Identifica de forma exclusiva seu navegador na DeepUnity PACSonWEB. Ele é usado para determinar se você será solicitado a inserir uma OTP durante o
                                logon ou não.
                            </td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Salva o último nível de saída de volume de áudio usado.</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td>Salva seu idioma de reconhecimento de fala preferido.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Salve seu fator de escala preferido e a resolução inicial correspondente.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Identifica quais pop-ups de itens de notícias você não deseja ver novamente.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Embora os cookies técnicos necessários não possam ser recusados pelo usuário do Site, pois são estritamente funcionais para o próprio Site, o usuário pode
                    escolher livremente aceitar ou recusar o uso de análises, criação de perfis e cookies não estritamente necessários. O usuário pode definir e revisar suas
                    escolhas em relação aos cookies com a função "configuração de cookies" disponível no site (Seção 'Legal')
                </p>
                <h2>3. Finalidades e base jurídicado tratamento</h2>
                <p>
                    Aousar os cookies, as seguintes finalidades são buscadas:
                    <br />
                    <br />
                    3.1. Para permitir a navegação do site Webse sua funcionalidade suave. A base legal para o processamento é a prestação aos usuários de serviços relacionados ao
                    site Website e o interesse legítimo da Dedalus em ter um site funcional.
                    <br />
                    3.2. Para cumprir quaisquer obrigações ao abrigo das leis, regulamentos ou legislação da UE aplicáveis, ou para dar cumprimento aos pedidos das autoridades. A
                    base legal para o processamento é a obrigação da Dedalus de cumprir a legislação obrigatória.
                    <br />
                    3.3. Analisar o comportamento do utilizador e eventualmente enviar-lhe mensagens publicitárias de acordo com as preferências expressas pelo mesmo durante a
                    navegação. A base legal para o processamento neste caso é o consentimento da parte interessada.
                    <br />
                    3.4. para as necessidades de defesa dos direitos de Dedalus no contexto de qualquer litígio, mesmo em tribunal. A base legal do processamento é o interesse
                    legítimo do Proprietário em proteger seus direitos.
                    <br />
                    <br />A cessão de Dados é facultativa, mas (exceto em casos de tratamento baseado em consentimento) a falha no fornecimento de Dados impede o Controladorde
                    permitir a navegação das Webs.
                </p>
                <h2>4. Destinatários dos Dados</h2>
                <p>
                    Os Dados podem ser comunicados :
                    <br />
                    <br />
                    (a) a terceiros que necessitem realizar atividades específicas em relação aos Dados, de acordo com as finalidades do processamento, ou a prestadores de serviços
                    ao Controlador de Dados.
                    <br />
                    (b) às autoridades, entidades e/ou partes a quem os Dados devam ser divulgados, nos termos de disposições legais ou contratuais vinculativas.
                    <br />
                    (c) em outras circunstâncias, como aquisições e vendas a potenciais empresas terceiras, quando esperamos vender ou transferir parte ou a totalidade dos nossos
                    negócios.
                </p>
                <h2>5. Transferência de dados para forado Espaço Económico Europeu</h2>
                <p>
                    Quanto à possível transferência de Dados para países não pertencentes ao Espaço Econômico Europeu, o tratamento ocorrerá de acordo com um dos métodos legalmente
                    permitidos e, portanto, através da seleção de destinatários estabelecidos em países considerados adequados pela Comissão Europeia ou através da estipulação de
                    cláusulas contratuais padrão.
                </p>
                <h2>6. Retenção de dados</h2>
                <p>
                    Os Dados serão conservados apenas pelo tempo necessário para as finalidades para as quais foram recolhidos, respeitando os princípios de limitação e minimização
                    da conservação. Mais precisamente, os termos de duração dos cookies são definidos na seção 2 anterior. Para os Dados cujo tratamento se baseia no consentimento
                    do interessado, especifica-se que os mesmos serão mantidos até que tal consentimento seja revogado.
                </p>
                <h2>7. Direitos dos titulares dos dados</h2>
                <p>
                    Na presença dos pré-requisitos legais relevantes, o titular dos dados pode solicitar ao Controlador de Dados ou ao DPO o acesso aos seus Dados, retificá-los ou
                    apagá-los ou opor-se ao seu processamento, solicitar a restrição do processamento nos casos previstos no Artigo 18 do RGPD, bem como obter de forma estruturada,
                    comumente utilizados e legíveis por máquina formatar os dados que lhe digam respeito, nos casos previstos no artigo 20 do RGPD.
                    <br />
                    <br />
                    Além disso, o usuário tem o direito de revogar qualquer consentimento para o processamento a qualquer momento, sem afetar a licitude do processamento realizado
                    pelo Controlador antes da revogação.
                    <br />
                    <br />
                    Os pedidos devem ser feitos por escrito ao Controlador de Dados nos endereços indicados acima.
                    <br />
                    Em qualquer caso, o interessado pode apresentar uma reclamação junto do Garante para a Proteção de Dados Pessoais se considerar que o tratamento dos seus Dados
                    é contrário à regulamentação em vigor.
                </p>
            </>
        );
    }
}
